export default __webpack_public_path__ + "static/media/lucky.94c06c52.png";